/// <reference path="appbase.ts" />
/// <reference path="../classes/PicklistProblemAssistant.ts" />


namespace TerminalApp {
    export class App_Picklist extends AppBase {
        listId: number;
        bound = false;
        pl_tote_info = document.getElementById("pl_tote_info");
        pl_tote_info_data = document.getElementById("pl_tote_info_data");
        pl_tote_info_close = document.getElementById("pl_tote_info_close");
        data_container = document.getElementById("pl_data");
        status_container = document.getElementById("pl_status");
        finish_button = document.getElementById("pl_finish_button");
        terminate_button = document.getElementById("pl_terminate_button");
        picked_count = document.getElementById("pl_picked_count");
        pick_count = document.getElementById("pl_pick_count");
        route = document.getElementById("pl_route");
        listname = document.getElementById("pl_name");
        pl_trolley = document.getElementById("pl_trolley");
        current: PickItem;
        current_group: PickGroup;
        current_hall: string;
        items: { [id: string]: PickItem } = {};
        sorted_items: PickItem[] = [];
        sorted_groups: PickGroup[] = [];
        orderTote: { [orderId: number]: ToteInfo } = {};
        data: SP.PickListInfo;

        ProblemAssistant: PicklistProblemAssistant;
        ProductionAssistant: FinishProductionAssistant;

        static instance: App_Picklist;
        TriggeredAudits: { [placementId: string]: SP.StockingLotInfo } = {};

        constructor() {
            super("app_picklist");

            this.ProblemAssistant = new PicklistProblemAssistant();
            this.ProductionAssistant = new FinishProductionAssistant();

            this.container.append(this.ProblemAssistant.container);
            this.container.append(this.ProductionAssistant.container);

            if (App_Picklist.instance != null) SP.alertX("already initialized app");
            App_Picklist.instance = this;

            this.terminate_button.addEventListener("click", async () => {
                if (!this.isAnyPicked()) {
                    this.terminatePickList(null);
                    return;
                }

                var info = `
                <div class='assistant_header_info_box'>${SP.Localize("sentance_select_destination_placement_for_tote_items")}</div>
                <div class="btn noselect keep_button"><div class="action">${SP.Localize("sentance_keep_current_totes")}</div></div><br>
                `;

                placementPickerAssistant.open(this.data.customerId, info, (placement) => {
                    this.terminatePickList(placement.id);
                });

                placementPickerAssistant.container.querySelector(".keep_button").addEventListener("click", () => {
                    this.terminatePickList(-1);
                    placementPickerAssistant.close();
                });
         
            });


            this.finish_button.addEventListener("click", async () => {

                if (!this.isAllPicked()) {
                    if (await SP.confirmX(SP.Localize("sentance_remove_all_unpicked_orders") + "?")) {
                        let result = await SP.get<any>(`/API/v1/PickList/clean/${this.listId}`);
                        if (result.status == 200) {
                            SP.Sounds.Success.play();
                            location.reload();
                            //TerminalApp.GetApp("app_picklist").open({ "id": this.listId.toString() });
                        }
                        else {
                            SP.Sounds.Error.play();
                            await SP.alertX("Error " + result.status + ": " + result.msg);
                        }
                    }
                    return;
                }


                if (this.data.pickSettings?.orderType == SP.OrderType.ProductionAssembly || this.data.pickSettings?.orderType == SP.OrderType.ProductionDisassembly) {
                    //console.log(this.data);
                        ///todo: Assistant to select finished quantity and prodctiontime
                        //result needs to get passed to finishPicklist to set the finished quantity and production time on orders
                    //for (var i = 0; i < this.data.productionOrders.length; i++) {
                    //}

                    var data : any = null;
                    
                    //Get item production data, and return if not filled
                    if (this.data.pickSettings?.orderType == SP.OrderType.ProductionAssembly) { 
                        var OrderInfo = await SP.Data.PickList.getPickListProductionData(this.listId);
                        data = await this.ProductionAssistant.open(OrderInfo);
                        if (data == null) return;
                    }

                    var info = `

                    <div class='assistant_header_info_box'>${SP.Localize("sentance_select_destination_placement_for_production_items")}</div>
                    <div class="btn noselect keep_button"><div class="action">${SP.Localize("sentance_keep_current_totes")}</div></div><br>
                    `;

                    if (this.data.pickSettings?.orderType == SP.OrderType.ProductionAssembly) {
                        info += (await this.getDestinations())?.outerHTML ?? "";
                    }

                    placementPickerAssistant.open(this.data.customerId, info, (placement) => {
                        this.finishPickList(null, placement.id, data);
                    });

                    placementPickerAssistant.container.querySelector(".keep_button").addEventListener("click", () => {
                        this.finishPickList(null, null, data);
                        placementPickerAssistant.close();
                    });

                    return;
                }


                if (this.data.pickSettings && this.data.pickSettings.printAllLabelOnFinishPickList) {
                    printerPickAssistant.open(SP.Localize("sentance_use_current_printer"), () => {
                        this.finishPickList(true, null, null);
                    });
                }
                else {
                    this.finishPickList(null, null, null);
                }
            });


            this.pl_tote_info_close.addEventListener("click", () => {
                this.pl_tote_info.style.display = "none";
            });
        }

        async getDestinations() {
            var orderInfo: SP.OrderInfo;

            var currentOrderId = null;

            for (var id in this.items) {
                var item = this.items[id];
                if (currentOrderId == null) {
                    currentOrderId = item.data.pickLineInfo.orderId;
                    orderInfo = await SP.Data.Order.getOrderInfo(item.data.pickLineInfo.orderId);
                }
                if (item.data.pickLineInfo.orderId != currentOrderId) return null; //dont suggest for multiple orders
            }

            var itemInfo = await SP.Data.Item.getItemInfo(orderInfo.collectionOrderItemId);

            var lots = await SP.Data.StockingLot.getItemStockingLotInfos(orderInfo.collectionOrderItemId, false);

            if (lots.length == 0) return null;

            //clear location info
            let loc_container = document.createElement("div");

            loc_container.style.backgroundColor = "#fff";
            loc_container.style.fontSize = "20px";
            loc_container.style.lineHeight = "40px";
            loc_container.style.textAlign = "center";
            loc_container.style.padding = "10px";

            var preferred = itemInfo.preferredStockPlacementData;

            //extract location inofo
            let locations = {} as any;

            if (preferred) {
                locations[preferred] = 0;
            }

            lots.forEach(l => {
                if (l.placementQuantity > 0) {
                    if (!locations[l.stockPlacementData]) locations[l.stockPlacementData] = l.placementQuantity;
                    else locations[l.stockPlacementData] += l.placementQuantity;
                }
            });



            for (var location in locations) {
                let t = new PlacementInfoBox(location, false, itemInfo);
                let amt = locations[location];

                let item = document.createElement("div");
                let location_span = document.createElement("span");
                let count_span = document.createElement("span");
                count_span.classList.add("label");
                location_span.innerHTML += t.string_location;

                if (preferred == location)
                    location_span.innerHTML += ' <i class="fa-solid fa-star"></i>';
                count_span.innerHTML = amt;




                item.appendChild(location_span);
                item.appendChild(count_span);

                loc_container.appendChild(item);
            }

            return loc_container;
        }

        async terminatePickList(destinationPlacementId: number) {
            StartLoading();
            try {
                let url = `/API/v1/PickList/cancel/${this.listId}`;
                if (destinationPlacementId) url += `?destinationPlacementId=${destinationPlacementId}`;

                let result = await SP.get<any>(url);

                if (result.status == 200) {
                    SP.Sounds.Success.play();
                    TerminalApp.GetApp("app_pick_orders").open();
                }
                else {
                    SP.Sounds.Error.play();
                    await SP.alertX("Error " + result.status + ": " + result.msg);
                }
            }
            finally {
                StopLoading();
            }
        }


        async finishPickList(autoPrint: boolean, destinationPlacementId: number, productionData: any) {
            StartLoading();
            try {
                let url = `/API/v1/PickList/finish/${this.listId}?autoPrint=${(autoPrint ? "true" : "false")}&label_printer=${App_Settings.terminalSettings.label_printer}&etiquette_printer=${App_Settings.terminalSettings.etiquette_printer}&a4_printer=${App_Settings.terminalSettings.a4_printer}`;

                if (destinationPlacementId) url += `&destinationPlacementId=${destinationPlacementId}`;

                let result = await SP.post<any>(url, productionData);

                if (result.status == 200) {
                    if (result.errors && result.errors.length) await SP.alertX("Error printing orders:\r\n\r\n" + result.errors.join("\r\n"));
                    SP.Sounds.Success.play();


                    if (this.data.pickSettings.quickPack) {
                        var toteId = 0;
                        for (var id in this.items) {
                            var item = this.items[id];
                            if (toteId && item.data.pickLineInfo.toteId != toteId) {
                                toteId = 0;
                                break;
                            }
                            toteId = item.data.pickLineInfo.toteId;
                        }
                        if (toteId) {
                            TerminalApp.GetApp("app_fast_pack_order").open({ tote: toteId });
                        }
                        else {
                            TerminalApp.GetApp("app_pick_orders").open();
                        }
                    }
                    else {
                        TerminalApp.GetApp("app_pick_orders").open();
                    }

                }
                else {
                    SP.Sounds.Error.play();
                    await SP.alertX("Error " + result.status + ": " + result.msg);
                }
            }
            finally {
                StopLoading();
            }
        }

        async onOpen() {
            this.listId = parseInt(SP.getHash("id"));



            this.reset();
            //bind events and groups
            if (!this.bound) {
                if (!await hub.connection.invoke<boolean>("controlPicklist", this.listId))
                    history.back();

                this.bound = true;
                barcodeListener.on("sp", this.scanPlacement, this);
                barcodeListener.on("t", this.scanToteEvent, this);
                barcodeListener.on("tr", this.setTrolley, this);
                barcodeListener.on(null, this.scanBarcode, this);
            }

            await this.loadData();




            //exit "onopen" before starting
            setTimeout(() => { this.start() }, 1);

        }

        async start() {
            if (this.data.pickSettings?.scanPickingTrolley && !this.data.trolley) {
                var trolleyId = await trolleyAssistant.open(false);
                if (!trolleyId) GetApp("app_pick_orders").open();
                await this.setTrolley(trolleyId);
            }
            else if (this.data.trolley) {
                await this.setTrolley(this.data.trolley.id);
            }

            if (this.sorted_groups.length)
                this.setNextGroup(true);
            else
                this.setNext(true);


        }

        async setTrolley(id: number | string) {
            var t = await SP.Data.Trolley.getTrolleyInfo(id as number);


            if (t.id != this.data.trolley?.id) {
                let result = await SP.get<any>(`/API/v1/PickList/setTrolley/${this.listId}?trolleyId=${t.id}`);
                if (result.status == 200) {
                    await Talk(t.name);
                }
            }
            this.data.trolley = t;

            this.pl_trolley.innerHTML = ` (${t.name})`;
        }


        async onClose() {
            if (this.bound) {
                toteAssistant.close();
                this.ProblemAssistant.close();
                await hub.connection.invoke<boolean>("releasePicklist");
                this.bound = false;
                barcodeListener.off("sp", this.scanPlacement);
                barcodeListener.off("t", this.scanToteEvent);
                barcodeListener.off("tr", this.setTrolley);
                barcodeListener.off(null, this.scanBarcode);
            }
            this.reset();
        }

        reset() {
            this.current = null;
            this.current_group = null;
            this.data_container.innerHTML = "";
            this.pl_trolley.innerHTML = "";
            this.items = {};
            this.sorted_items = [];
            this.current_hall = null;
        }

        async ItemPickButtonClick(item: PickItem, confirm_finished: boolean = true) {
            if (await item.post(null, !confirm_finished)) {
                this.setOrderTote(item, confirm_finished);
                if (item.allPicked) this.setNext();
                this.updateStatus();
            }

        }

        async loadData() {
            this.data = await SP.Data.PickList.getPickListInfo(this.listId, true);

            this.terminate_button.style.display = this.data.pickListAttention ? "block" : "none";

            //don
            if (this.data.picked)
                return history.back();

            let data = await SP.Data.PickList.getPickListLinesData(this.listId);
            this.sorted_groups = [];
            let currentGroupKey = "";
            let currentGroup: PickItem[] = null;
            let groupContainer = this.data_container;
            let groups: PickItem[][] = [];



            for (let i = 0; i < data.length; i++) {
                let itemdata = data[i];


                if (this.data.pickListGrouped) {
                    var groupKey = itemdata.stockingLotInfo.stockPlacementId + "-" + itemdata.stockingLotInfo.item.id;
                    if (groupKey != currentGroupKey) {
                        currentGroup = [];
                        groupContainer = document.createElement("div");
                        groupContainer.classList.add("picking_group", groupKey);
                        groups.push(currentGroup);
                        this.data_container.appendChild(groupContainer);
                        currentGroupKey = groupKey;
                    }
                }

                let item = new PickItem(itemdata, this.listId);
                if (this.data.pickListGrouped) currentGroup.push(item);

                this.sorted_items[i] = item;
                this.items[itemdata.pickLineInfo.id] = item;
                item.container.classList.add("noselect");
                item.index = i;
                item.container.addEventListener("click", () => {
                    if (item != this.current) {
                        this.setActiveLine(item.data.pickLineInfo.id);
                        SP.Sounds.Click.play();
                    }
                });
                item.menu = new SP.SwipeMenu(
                    /*Element*/
                    item.container,

                    /*Click Event*/
                    null,

                    /*buttons*/
                    [
                        /*Move Button  */{
                            icon: "<i class='fas fa-exclamation-circle'></i>", text: SP.Localize("word_problem"), color: "#e83535", confirm: false, action: async () => {
                                this.ProblemAssistant.open(itemdata, this.data, item.placementInfoBox.string_location, () => {
                                    if (this.sorted_items.length == 0) {
                                        this.finish_button.click();
                                    }
                                });
                                item.menu.return();
                            }
                        }
                    ],

                    "app_picklist"
                );


                groupContainer.appendChild(item.container);
                this.setOrderTote(item, false);
            }


            if (this.data.pickListGrouped) {

                for (let i = groups.length - 1; i >= 0; i--) {
                    let group = new PickGroup(groups[i], groups[i][0].container.parentElement as HTMLDivElement);
                    group.container.addEventListener("click", e => {
                        if (!group.container.classList.contains("focus")) {
                            this.setActiveGroup(group);
                        }
                    });
                    this.sorted_groups.push(group);
                    this.data_container.insertBefore(group.container, group.child_contianer);
                }

                this.sorted_groups.reverse();
            }

            this.listname.innerHTML = this.data.stockName + " #" + this.data.pickListId;
            this.route.innerHTML = Math.round(this.data.pickListRouteLength) + "m";

            this.updateStatus();
        }

        async removeLine(lineId: string, qty: number, removeFromOrder: boolean) {
            StartLoading();
            try {
                let data = {
                    listId: this.listId,
                    lineId: lineId,
                    qty: qty,
                    removeFromOrder: removeFromOrder
                };

                let result = await SP.post<any>("/API/v1/PickList/removeLine/", data);
                if (result.status == 200) {
                    SP.Sounds.Success.play();

                    //remove items and html
                    for (let i = this.sorted_items.length - 1; i >= 0; i--) {
                        let item = this.sorted_items[i];
                        if (item.data.pickLineInfo.id == lineId) {
                            item.data.pickLineInfo.quantity -= qty;
                            item.data.pickLineInfo.pickedQuantity = Math.min(item.data.pickLineInfo.quantity, item.data.pickLineInfo.pickedQuantity);
                            if (item.data.pickLineInfo.quantity <= 0) {
                                item.menu.remove();
                                item.container.remove();
                                item.update();
                                this.sorted_items.splice(i, 1);
                                delete this.items[item.data.pickLineInfo.id];
                                item.parent_group?.removeItem(item);
                            }
                            else {
                                item.amount_input.value = item.data.pickLineInfo.pickedQuantity.toString();
                                item.input_box.querySelector(".max_qty").innerHTML = item.data.pickLineInfo.quantity.toString();
                            }
                            break;
                        }
                    }

                    //update index for remaining
                    for (let i = 0; i < this.sorted_items.length; i++) {
                        this.sorted_items[i].index = i;
                    }


                }
                else {
                    await SP.alertX("Error " + result.status + ": " + result.msg);
                    return false;
                }

                this.updateStatus();
                return true;
            }
            finally {
                StopLoading();
            }
        }


        async changeLine(lineId: string, qty: number, newLotId: string) {
            StartLoading();
            try {
                let data = {
                    listId: this.listId,
                    lineId: lineId,
                    quantity: qty,
                    newLotId: newLotId
                };

                let result = await SP.post<any>("/API/v1/PickList/changePlacement/", data);
                if (result.status == 200) {
                    SP.Sounds.Success.play();
                }
                else {
                    await SP.alertX("Error " + result.status + ": " + result.msg);
                    return false;
                }

                this.updateStatus();
                return true;
            }
            finally {
                StopLoading();
            }
        }



        removeGroup(g: PickGroup) {
            this.sorted_groups.splice(this.sorted_groups.indexOf(g), 1);
            if (g == this.current_group) this.setNextGroup();
            g.container.remove();

        }


        async removeShipment(shipmentId: string) {
            StartLoading();
            let data = {
                listId: this.listId,
                shipmentId: shipmentId,
            }

            let result = await SP.post<any>("/API/v1/PickList/moveShipment/", data);
            if (result.status == 200) {
                SP.Sounds.Success.play();

                //remove items and html
                for (let i = this.sorted_items.length - 1; i >= 0; i--) {
                    let item = this.sorted_items[i];

                    if (item.data.pickLineInfo.shipmentId == shipmentId) {
                        item.menu.remove();
                        item.container.remove();
                        this.sorted_items.splice(i, 1);
                        delete this.items[item.data.pickLineInfo.id];

                        //reomve from group
                        item.parent_group?.removeItem(item);
                    }
                }

                //update index for remaining
                for (let i = 0; i < this.sorted_items.length; i++) {
                    this.sorted_items[i].index = i;
                }

                this.setNext(true);

            }
            else {
                await SP.alertX("Error " + result.status + ": " + result.msg);
            }

            this.updateStatus();

            StopLoading();
        }

        setOrderTote(item: PickItem, confirm_finish: boolean) {
            let orderId = item.data.pickLineInfo.orderId;
            let toteInfo = new ToteInfo(item.data.pickLineInfo.toteId, item.data.pickLineInfo.toteName, item.data.pickLineInfo.toteColor);
            var currentToteInfo = this.orderTote[item.data.pickLineInfo.orderId];
            var siblings = this.sorted_items.filter(i => i.data.pickLineInfo.orderId == item.data.pickLineInfo.orderId && i != item);

            //Update sibling locations
            var all_finish = item.allPicked;
            if (toteInfo.id != -1) {
                this.orderTote[orderId] = toteInfo;
                siblings.forEach(s => {
                    if (s.Picked) return;
                    s.data.pickLineInfo.toteId = toteInfo.id;
                    s.data.pickLineInfo.toteColor = toteInfo.color;
                    s.data.pickLineInfo.toteName = toteInfo.name;
                    s.update();

                    if (!s.allPicked) all_finish = false;
                });
            }

            //update self location
            else if (currentToteInfo != null && siblings.some(s => s.hasActualTote)) {
                item.data.pickLineInfo.toteId = currentToteInfo.id;
                item.data.pickLineInfo.toteColor = currentToteInfo.color;
                item.data.pickLineInfo.toteName = currentToteInfo.name;
                item.update();
            }

            //clear locations
            else {
                delete this.orderTote[orderId];
                siblings.forEach(s => {
                    s.data.pickLineInfo.toteId = toteInfo.id;
                    s.data.pickLineInfo.toteColor = toteInfo.color;
                    s.data.pickLineInfo.toteName = toteInfo.name;
                    s.update();
                });
            }

            if (confirm_finish && all_finish && App_Settings.userSettings.voice_picklist_read_tote) {
                Talk(SP.Localize("sentance_tote_finished"), App_Settings.userSettings.voice_delay);
            }

        }
        async setNextGroup(first: boolean = false) {
            await this.checkForAudits();

            if (!this.current_group && !first) return;
            console.log("setNextGroup");
            let currentIndex = first ? -1 : this.sorted_groups.indexOf(this.current_group);



            for (let x = currentIndex + 1; x < this.sorted_groups.length; x++) {
                let item2 = this.sorted_groups[x];
                if (!item2.allPicked) {
                    this.setActiveGroup(item2);
                    break;
                }
            }


        }


        async setNext(first: boolean = false) {

            if (!this.current && !first) return;
            let currentIndex = first ? -1 : this.current.index;

            if (this.current != null) {
                this.current.container.classList.add("small");
                this.current.container.classList.remove("focus");
                this.current = null;
            }

            //dont open next for grouped
            if (this.data.pickListGrouped) return;

            await this.checkForAudits();


            for (let x = currentIndex + 1; x < this.sorted_items.length; x++) {
                let item2 = this.sorted_items[x];
                if (item2.data.pickLineInfo.pickedQuantity != item2.data.pickLineInfo.quantity) {
                    this.setActiveLine(item2.data.pickLineInfo.id);
                    break;
                }
            }
        }

        async changeHall(hallName: string) {
            if (hallName != this.current_hall) {
                var change = this.current_hall;
                this.current_hall = hallName;
                if (change) {

                    document.getElementById("pl_hall_name").innerHTML = SP.Localize("word_hall") + " " + hallName;
                    document.getElementById("pl_hall_info").style.opacity = "0.8";
                    if (App_Settings.userSettings.voice_picklist_read_placement) {
                        Talk(SP.Localize("sentance_move_to") + " " + SP.Localize("word_hall") + " " + hallName, App_Settings.userSettings.voice_delay);
                    }
                    await SP.sleep(5000);
                    document.getElementById("pl_hall_info").style.opacity = "0";
                }
            }
        }


        async setActiveGroup(g: PickGroup) {
            if (this.current_group != null) {
                this.current_group.pick_box.style.pointerEvents = "none";
                this.current_group.container.classList.remove("focus");
                this.current_group.container.classList.add("small");
                if (this.current_group.isOpen) this.current_group.showPicks();
            }
            this.current_group = g;

            if (this.current_group) {
                this.current_group.container.classList.add("focus");
                this.current_group.container.classList.remove("small");
                this.current_group.pick_box.style.pointerEvents = "all";
                await this.centerToCurrent(true);
            }
            await SP.sleep(0);

            //read location
            if (this.current_group) {
                this.changeHall(this.current_group.placementInfoBox.hall);

                await SP.sleep(400);
                if (this.current_group) {

                    if (!this.current_group.allPicked) {

                        if (App_Settings.userSettings.voice_picklist_read_placement)
                            Talk(this.current_group.placementInfoBox.pronounciation, App_Settings.userSettings.voice_delay);

                        if (App_Settings.userSettings.voice_picklist_read_quantity)
                            Talk(SP.Localize("word_pick") + " " + this.current_group.totalCount.toString(), App_Settings.userSettings.voice_delay);
                    }
                }
            }
        }


        async setActiveLine(lineId: string) {
            if (this.current != null) {
                this.current.container.classList.add("small");
                this.current.container.classList.remove("focus");
            }
            //set hash
            ignoreHashChange = true;
            //SP.setHash("line", lineId);


            this.current = this.items[lineId];


            if (this.current) {
                this.changeHall(this.current.placementInfoBox.hall);
                this.current.container.classList.remove("small");
                this.current.container.classList.add("focus");

                await this.centerToCurrent();

                if (this.current.data.orderWarehouseNotificationPicker) {
                    new SP.DismissInfo("Warehouse Notification (Order)", this.current.data.orderWarehouseNotificationPicker);
                }

                if (this.current.data.stockingLotInfo.item.warehouseNotificationPicker) {
                    new SP.DismissInfo("Warehouse Notification (Item:" + this.current.data.stockingLotInfo.item.sku + ")", this.current.data.stockingLotInfo.item.warehouseNotificationPicker);
                }
            }
            await SP.sleep(0);
            ignoreHashChange = false;

            //read location
            if (this.current) {
                await SP.sleep(400);
                if (this.current) {
                    if (App_Settings.userSettings.voice_picklist_read_placement)
                        Talk(this.current.placementInfoBox.pronounciation, App_Settings.userSettings.voice_delay);

                    if (App_Settings.userSettings.voice_picklist_read_quantity)
                        Talk(SP.Localize("word_pick") + " " + this.current.data.pickLineInfo.quantity.toString(), App_Settings.userSettings.voice_delay);
                }
            }
        }

        async centerToCurrent(groupPick: boolean = false) {
            await SP.sleep(1);
            var elm = groupPick ? this.current_group : this.current;
            if (elm != null) {
                if (elm) {
                    elm.container.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                        inline: 'center'
                    });
                }
            }
        }

        async scanPlacement(placementId: string) {
            console.log("Settings:", this.data.pickSettings?.allowLocationScanPicking);
            if (this.data.pickSettings?.allowLocationScanPicking === 0) {
                this.current.showError(SP.Localize("sentance_location_scanning_disabled") + "!");
                return;
            }

            //group scanning
            if (this.current_group != null) {

                //multiple skus check
                if (!this.current_group.childen[0].data.pickLineInfo.allowLocationScanPicking) {
                    return this.current.showError(SP.Localize("sentance_location_scanning_disabled") + "!");
                }

                if (this.current_group.data.stockingLotInfo.stockPlacementId.toString() == placementId) {
                    if (this.data.pickSettings?.groupPickSingleScan ?? true)
                        this.current_group.pickAll();
                    else
                        this.current_group.scanOne(1);
                }
                else {
                    SP.Sounds.Error.play();
                }
                return;
            }


            if (this.current.data.stockingLotInfo.stockPlacementId.toString() == placementId) {

                //multiple skus check
                console.log("Settings:", this.current.data);
                if (!this.current.data.pickLineInfo.allowLocationScanPicking) {
                    return this.current.showError(SP.Localize("sentance_location_scanning_disabled") + "!");
                }

                this.current.plus_click(false, 1);
            }
            else {
                this.current.showError(SP.Localize("sentance_scanning_wrong_location") + "!");
            }
        }

        async scanBarcode(barcode: string) {
            //get scanned barcode without leading zeroes
            var code = barcode.replace(/^0+/, '');

            //group scanning
            if (this.current_group != null) {
                var qty = GetBarcodeQty(this.current_group.data.stockingLotInfo.item.allBarcodes, code);
                var soft_match = App_Settings.wmsSettings.allow_soft_barcode_match && this.current_group.matchKeyword(code);

                if (qty != null || soft_match) {
                    if (this.data.pickSettings?.groupPickSingleScan ?? true)
                        this.current_group.pickAll();
                    else {
                        this.current_group.scanOne(qty);
                    }
                }
                else {
                    SP.Sounds.Error.play();
                }
                return;
            }


            if (this.current != null) {
                //click the plus button if match
                var qty = GetBarcodeQty(this.current.data.stockingLotInfo.item.allBarcodes, code);
                var soft_match = App_Settings.wmsSettings.allow_soft_barcode_match && this.current.matchKeyword(code);
                if (qty != null || soft_match) {
                    this.current.clearError();
                    this.current.plus_click(true, qty);
                }
                else {
                    this.current.showError(SP.Localize("sentance_no_barcode_match") + "!");
                }
            }
        }

        isAllPicked() {
            var picked = this.sorted_items.reduce((a, b) => a + b.data.pickLineInfo.pickedQuantity, 0);
            var pick = this.sorted_items.reduce((a, b) => a + b.data.pickLineInfo.quantity, 0);
            return picked == pick;
        }

        isAnyPicked() {
            var picked = this.sorted_items.reduce((a, b) => a + b.data.pickLineInfo.pickedQuantity, 0);
            return picked > 0;
        }

        updateStatus() {
            var picked = this.sorted_items.reduce((a, b) => a + b.data.pickLineInfo.pickedQuantity, 0);
            var pick = this.sorted_items.reduce((a, b) => a + b.data.pickLineInfo.quantity, 0);
            this.picked_count.innerHTML = picked.toString();
            this.pick_count.innerHTML = pick.toString();
            this.finish_button.style.pointerEvents = "all";
            if (picked == pick)
                this.finish_button.classList.remove("disabled");
            else
                this.finish_button.classList.add("disabled");

        }

        lastToteScan: string = "";
        lastScanTime: number = 0;

        scanToteEvent(toteId: string) {
            this.scanTote(toteId);
            if (App_Settings.userSettings.auto_double_scan_picking) this.scanTote(toteId);
            return false;
        }


        async scanTote(toteId: string) {

            var now = performance.now();

            //double scan
            if (this.lastToteScan != toteId || this.lastScanTime + 1000 < now) {
                this.lastToteScan = toteId;
                this.lastScanTime = performance.now();
                return;
            }


            if (this.current != null) {
                await this.PickOrderWithToteScan(this.current, toteId);
            }
            this.pl_tote_info.style.display = "none";
            this.lastToteScan = "";
        }

        async PickOrderWithToteScan(item: PickItem, toteId: string) {
            if (await this.current.post(parseInt(toteId))) {
                this.setOrderTote(item, true);
                if (item.allPicked) this.setNext();
                this.updateStatus();
            }
            // await this.checkForAudits();
        }

        async checkForAudits() {
            console.log("Check for audits!", this.TriggeredAudits);

            for (var placementId in this.TriggeredAudits) {
                var lotInfo = this.TriggeredAudits[placementId];
                await quickAuditAssistant.open(lotInfo);
            }
            this.TriggeredAudits = {};
        }


        showToteContent(orderId: number) {

            var items = this.sorted_items.filter(i => i.data.pickLineInfo.orderId == orderId);

            if (items.length <= 1) return;

            this.pl_tote_info_data.innerHTML = "";

            for (let i = 0; i < items.length; i++) {
                let item = items[i];
                let qty = item.data.pickLineInfo.quantity;
                let sku = item.data.stockingLotInfo.item.sku;
                let man = item.data.stockingLotInfo.item.manufacturerName;
                let model = item.data.stockingLotInfo.item.modelNo;
                let desc = item.data.stockingLotInfo.item.description;
                let img = item.data.imageUrl;

                var container = this.pl_tote_info_data.appendChild(document.createElement("div"));

                container.innerHTML = `<span class="image"><img src="${img}" /></span>`;
                container.innerHTML += ` <span class="qty label">${qty}</span>`;
                container.innerHTML += ` <span class="sku">${sku}</span>`;
                if ((man + model).length)
                    container.innerHTML += ` <span class="name">${man + " " + model}</span>`;
                container.innerHTML += `<br><span class="desc">${desc}</span>`;


            }


            this.pl_tote_info.style.display = "block";

        }
    }
    RegisterApp("app_picklist", App_Picklist);






    export class PickGroup extends LotInfoBox {

        toggle_button: HTMLElement;
        pick_button: HTMLElement;
        pick_box: HTMLElement;
        input_box: HTMLElement;
        error: HTMLElement;
        data: SP.PickListLineData;
        status_icon: HTMLElement;
        scanCount: number = 0;
        totalCount: number = 0;
        child_contianer: HTMLDivElement;
        childen: PickItem[];
        searchString: string;

        constructor(list: PickItem[], childContainer: HTMLDivElement) {
            super(list[0].data.stockingLotInfo, list[0].data.description);
            this.child_contianer = childContainer;
            let data = list[0].data;
            this.data = data;
            this.childen = list;


            for (let i = 0; i < list.length; i++) {
                let item = list[i];
                item.parent_group = this;
            }

            this.container.classList.add("group_pick", "small");

            this.status_icon = this.container.appendChild(document.createElement("div"));
            this.status_icon.classList.add("pick_status");


            this.error = this.inner_container.appendChild(document.createElement("div"));
            this.error.classList.add("error");



            this.pick_box = this.inner_container.appendChild(document.createElement("div"));
            this.pick_box.classList.add("pick_status_box", "noselect");
            this.pick_box.style.pointerEvents = "none";
            this.toggle_button = this.pick_box.appendChild(document.createElement("div"));
            this.toggle_button.innerHTML = SP.Localize("sentance_show_picks");
            this.toggle_button.classList.add("button", "plus", "grad-gray");
            this.toggle_button.addEventListener("click", () => {
                this.showPicks();
            });

            this.input_box = this.pick_box.appendChild(document.createElement("div"));
            this.input_box.classList.add("input_box");


            this.pick_button = this.pick_box.appendChild(document.createElement("div"));
            this.pick_button.innerHTML = SP.Localize("sentance_pick_all").toUpperCase();
            this.pick_button.classList.add("button", "pick", "grad-green");
            this.pick_button.addEventListener("click", async () => {
                if (this.allPicked) this.unpickAll();
                else {
                    this.pickAll();
                }

            });

            this.child_contianer.style.display = "none";
            this.updatePickCounts();
            this.update();

            if (this.allPicked) this.container.classList.add("finished");

            var barcodes = [];

            for (var bc in this.data.stockingLotInfo.item.allBarcodes) {
                barcodes.push(bc);
            }

            var barcodeStringNoZero = "";
            for (var barcode in barcodes) {
                barcodeStringNoZero += barcode.trim().replace(/^0+/, '');
            }

            this.searchString = (barcodeStringNoZero + " " + barcodes.join(" ") + " " + this.data.stockingLotInfo.item.sku + " " + this.data.stockingLotInfo.item.manufacturerName + " " + this.data.stockingLotInfo.item.modelNo).toLocaleLowerCase();

        }

        updatePickCounts() {
            this.totalCount = 0;
            this.scanCount = 0;
            for (let i = 0; i < this.childen.length; i++) {
                let item = this.childen[i];
                this.totalCount += item.data.pickLineInfo.quantity;

            }
            this.input_box.innerHTML = "<span class='scanCount'></span>" + this.pickedQuantity + " / " + this.totalCount;
        }

        removeItem(item: PickItem) {
            this.childen.splice(this.childen.indexOf(item), 1);
            if (this.childen.length) this.updatePickCounts();
            else App_Picklist.instance.removeGroup(this);
        }

        async scanOne(qty: number) {
            this.scanCount += (qty ? qty : 1);
            this.input_box.querySelector(".scanCount").innerHTML = `( ${this.scanCount} ) `;
            if (this.scanCount == this.totalCount) this.pickAll();
        }

        async pickAll() {
            if (this.allPicked) return;
            for (let i = 0; i < this.childen.length; i++) {
                let c = this.childen[i];
                c.amount_input.value = c.data.pickLineInfo.quantity.toString();
                if (c.data.pickLineInfo.toteId <= 0) {
                    var tote = await SP.Data.Tote.getTempToteInfo();
                    c.data.pickLineInfo.toteId = tote.toteId;
                }
                await App_Picklist.instance.ItemPickButtonClick(c, false);
                this.update();
            }

            //  await App_Picklist.instance.checkForAudits();


            if (this.allPicked) {
                if (App_Settings.userSettings.voice_picklist_read_quantity) Talk(this.totalCount.toString(), App_Settings.userSettings.voice_delay);
                App_Picklist.instance.setNextGroup();
                this.container.classList.add("finished");
                SP.Sounds.Success.play();
            } else {
                SP.Sounds.Error.play();
            }
        }

        async unpickAll() {
            for (let i = 0; i < this.childen.length; i++) {
                let c = this.childen[i];
                c.amount_input.value = "0";
                await App_Picklist.instance.ItemPickButtonClick(c, false);
                this.update();
                if (!this.allPicked) {
                    this.container.classList.remove("finished");
                }

                if (this.pickedQuantity > 0) SP.Sounds.Error.play();
                else SP.Sounds.Success.play();
            }
            //await App_Picklist.instance.checkForAudits();


        }


        get pickedQuantity() {
            let totalPicked = 0;
            for (let i = 0; i < this.childen.length; i++) {
                totalPicked += this.childen[i].data.pickLineInfo.pickedQuantity;
            }
            return totalPicked;
        }

        get Picked() {
            return this.pickedQuantity > 0;
        }

        get allPicked() {
            return this.pickedQuantity == this.totalCount;
        }

        isOpen = false;

        showPicks() {
            var hidden = this.child_contianer.style.display == "none";
            this.toggle_button.innerHTML = hidden ? SP.Localize("sentance_hide_picks") : SP.Localize("sentance_show_picks");
            this.child_contianer.style.display = hidden ? "block" : "none";
            this.isOpen = hidden;

        }

        update() {
            if (this.Picked) {
                this.pick_button.innerHTML = SP.Localize("word_unpick").toUpperCase();
                this.pick_button.classList.add("grad-red");
                this.status_icon.innerHTML = this.allPicked ? '<i class="fas fa-check"></i>' : '<i class="fas fa-exclamation"></i>';
                this.status_icon.style.color = this.allPicked ? '#81da78' : '#ff8f8f';
            }
            else {
                this.pick_button.classList.remove("grad-red");
                this.pick_button.innerHTML = SP.Localize("word_pick").toUpperCase();
                this.status_icon.innerHTML = "";
            }
            this.input_box.innerHTML = "<span class='scanCount'></span>" + this.pickedQuantity + " / " + this.totalCount;
            this.scanCount = 0;
        }

        showError(msg: string) {
            SP.Sounds.Error.play();
            this.error.style.display = "block";
            this.error.innerHTML = msg;
            App_Picklist.instance.centerToCurrent();
        }

        clearError() {
            this.error.style.display = "none";
            App_Picklist.instance.centerToCurrent();
        }


        matchKeyword(keywords: string) {
            return !keywords.toLowerCase().split(' ').some(kw => this.searchString.indexOf(kw) == -1);
        }
    }

    export class PickItem extends LotInfoBox {
        minus_button: HTMLElement;
        plus_button: HTMLElement;
        pick_button: HTMLElement;
        pick_box: HTMLElement;
        input_box: HTMLElement;
        tote_box: HTMLElement;
        error: HTMLElement;
        amount_input: HTMLInputElement;
        data: SP.PickListLineData;
        parent_group: PickGroup;
        index = 0;
        menu: SP.SwipeMenu;
        scanCount = 0;
        listId = 0;
        status_icon: HTMLElement;
        searchString: string;

        constructor(data: SP.PickListLineData, listId: number) {
            super(data.stockingLotInfo, data.description);
            this.listId = listId;
            this.data = data;
            this.container.classList.add("small");
            this.status_icon = this.container.appendChild(document.createElement("div"));
            this.status_icon.classList.add("pick_status");
            this.error = this.inner_container.appendChild(document.createElement("div"));
            this.error.classList.add("error");
            this.pick_box = this.inner_container.appendChild(document.createElement("div"));
            this.pick_box.classList.add("pick_status_box", "noselect");
            this.minus_button = this.pick_box.appendChild(document.createElement("div"));
            this.minus_button.innerHTML = '<i class="fas fa-minus"></i>';
            this.minus_button.classList.add("button", "minus", "grad-gray");
            SP.bindClickHold(this.minus_button, 700, () => {
                this.minus_click();
            }, () => {
                this.minus_hold();
            });

            console.log("DATA:", data);

            this.input_box = this.pick_box.appendChild(document.createElement("div"));
            this.input_box.classList.add("input_box");
            this.input_box.innerHTML = " / <span class='max_qty'>" + data.pickLineInfo.quantity + '  ' + data.stockingLotInfo.item.unitType + '</span>';
            this.amount_input = document.createElement("input");
            this.input_box.prepend(this.amount_input);
            this.amount_input.type = "number";
            this.amount_input.value = data.pickLineInfo.pickedQuantity.toString();

            this.amount_input.addEventListener("focus", e => {
                this.amount_input.select();
            });

            this.plus_button = this.pick_box.appendChild(document.createElement("div"));
            this.plus_button.innerHTML = '<i class="fas fa-plus"></i>';
            this.plus_button.classList.add("button", "plus", "grad-gray");
            SP.bindClickHold(this.plus_button, 700, () => {
                this.plus_click(false, 1);
            }, () => {
                this.plus_hold();
            });

            this.pick_button = this.pick_box.appendChild(document.createElement("div"));
            this.pick_button.innerHTML = SP.Localize("word_pick").toUpperCase();
            this.pick_button.classList.add("button", "pick", "grad-green");
            this.pick_button.addEventListener("click", async () => {
                var qty = this.data.pickLineInfo.quantity;
                var picked = parseInt(this.amount_input.value);
                var allPicked = qty == picked;

                //simple handling (auto pick click)
                if (allPicked && App_Picklist.instance.data.pickSettings.picklistType == SP.PicklistType.Simple) {
                    if (App_Settings.userSettings.voice_picklist_read_quantity) Talk(picked.toString(), App_Settings.userSettings.voice_delay);

                    if (this.data.pickLineInfo.toteId <= 0) {
                        await this.pickWithTempTote();
                        return;
                    }
                }

                await App_Picklist.instance.ItemPickButtonClick(this);
                //await App_Picklist.instance.checkForAudits();
            });

            this.tote_box = this.pick_box.appendChild(document.createElement("div"));
            this.tote_box.classList.add("tote");
            this.tote_box.innerHTML = "?";

            var clicked = false;
            this.tote_box.addEventListener("pointerdown", () => {
                if (this.IsFocused) {
                    document.addEventListener("pointerup", upEvent);
                    this.tote_box.addEventListener("pointerleave", leaveEvent);
                    clicked = true;

                    setTimeout(async () => {
                        if (clicked) {
                            clicked = false;
                            await this.pickWithTempTote();
                        }
                    }, 800);
                }
            });

            var leaveEvent = () => {
                clicked = false;
                this.tote_box.removeEventListener("pointerleave", leaveEvent);
            }

            var upEvent = () => {
                if (this.IsFocused) {
                    if (clicked) {
                        toteAssistant.open(true, (toteId) => {
                            App_Picklist.instance.scanTote(toteId.toString());
                            App_Picklist.instance.scanTote(toteId.toString());
                        });
                    }
                }
                document.removeEventListener("pointerup", upEvent);
            }

            var barcodes = [];
            for (var bc in this.data.stockingLotInfo.item.allBarcodes) {
                barcodes.push(bc);
            }

            var barcodeStringNoZero = "";
            for (var barcode in barcodes) {
                barcodeStringNoZero += barcode.trim().replace(/^0+/, '');
            }


            this.searchString = (barcodeStringNoZero + " " + barcodes.join(" ") + " " + this.data.stockingLotInfo.item.sku + " " + this.data.stockingLotInfo.item.manufacturerName + " " + this.data.stockingLotInfo.item.modelNo).toLocaleLowerCase();

            //Update special image
            if (data.imageUrl && data.imageUrl != data.stockingLotInfo.item.imageUrl) (this.inner_container.querySelector(".image") as HTMLImageElement).src = data.imageUrl;

            this.text_container.innerHTML += `<span class='orderno'>${SP.Localize("word_order") + ' ' + data.pickLineInfo.orderNo}</span>`;

            if (data.extraText) {
                this.text_container.innerHTML += `<span class='extraText'>${data.extraText}</span>`;
            }

            if (data.stockingLotInfo.batchNumber) {
                this.text_container.innerHTML += `<span class='batchNumber'>BATCH: <b>${data.stockingLotInfo.batchNumber}</b></span>`;
            }

            this.update();
        }

        async pickWithTempTote() {
            var tote = await SP.Data.Tote.getTempToteInfo();
            App_Picklist.instance.PickOrderWithToteScan(this, tote.toteId.toString());
        }

        get IsFocused() {
            return this.container.classList.contains("focus");
        }

        get Picked() {
            return this.data.pickLineInfo.pickedQuantity > 0;
        }

        get allPicked() {
            return this.data.pickLineInfo.pickedQuantity == this.data.pickLineInfo.quantity;
        }

        get hasActualTote() {
            return this.data.pickLineInfo.pickedQuantity > 0 && this.data.pickLineInfo.toteId != -1;
        }

        matchKeyword(keywords: string) {
            return !keywords.toLowerCase().split(' ').some(kw => this.searchString.indexOf(kw) == -1);
        }

        update() {
            if (this.data.pickLineInfo.toteId > -1) {
                this.tote_box.innerHTML = this.data.pickLineInfo.toteName;
                this.tote_box.style.backgroundColor = this.data.pickLineInfo.toteColor;
                this.tote_box.style.textShadow = "0px 1px 6px #000000";
                this.tote_box.style.color = "#fff";
            }
            else {
                this.tote_box.innerHTML = "?";
                this.tote_box.style.backgroundColor = "";
                this.tote_box.style.textShadow = "";
                this.tote_box.style.color = "";
            }


            if (this.Picked) {
                this.status_icon.innerHTML = this.allPicked ? '<i class="fas fa-check"></i>' : '<i class="fas fa-exclamation"></i>';
                this.status_icon.style.color = this.allPicked ? '#81da78' : '#ff8f8f';
            }
            else
                this.status_icon.innerHTML = "";
        }

        async plus_click(scanned: boolean, qty: number) {
            this.clearError();

            var amt = Math.max(parseFloat(this.amount_input.value) + (qty ? qty : 1), 0);
            this.amount_input.value = amt.toString();
            if (scanned) this.scanCount++;
            var allScanned = amt == this.data.pickLineInfo.quantity;

            //simple handling (auto pick click)
            if (allScanned && App_Picklist.instance.data.pickSettings.picklistType == SP.PicklistType.Simple) {
                this.pick_button.click();
                return;
            }

            if (allScanned && this.data.pickLineInfo.toteId <= 0) {
                App_Picklist.instance.showToteContent(this.data.pickLineInfo.orderId);

            }

            if (allScanned && App_Settings.userSettings.voice_picklist_read_tote) {
                if (this.data.pickLineInfo.toteId > 0)
                    Talk(SP.Localize("word_tote") + " " + this.data.pickLineInfo.toteName, App_Settings.userSettings.voice_delay);
                else
                    Talk(SP.Localize("sentance_scan_new_tote") + " " + this.data.pickLineInfo.toteName, App_Settings.userSettings.voice_delay);
            }
        }

        plus_hold() {
            this.clearError();

            this.amount_input.value = Math.max(parseFloat(this.amount_input.value), this.data.pickLineInfo.quantity).toString();
        }

        minus_click() {
            this.clearError();

            this.amount_input.value = Math.max(parseFloat(this.amount_input.value) - 1, 0).toString();
        }

        minus_hold() {
            this.clearError();

            this.amount_input.value = "0";
        }

        async post(toteId: number, silent: boolean = false) {
            StartLoading(true, true);

            //pick click
            if (toteId == null)
                toteId = this.data.pickLineInfo.toteId;

            let data = {
                listId: this.listId,
                lineId: this.data.pickLineInfo.id,
                toteId: toteId,
                quantity: parseFloat(this.amount_input.value),
                scanned: this.scanCount > 0
            }

            let result = await SP.post<any>("/API/v1/PickList/updateLine/", data);
            if (result.status == 200) {
                this.clearError();
                if (!silent) SP.Sounds.Success.play();
                this.data.pickLineInfo = result.data;
                this.update();


                //force quickAudit
                if (result.triggerAudit) {
                    App_Picklist.instance.TriggeredAudits[this.data.stockingLotInfo.stockPlacementId] = this.data.stockingLotInfo;
                }

            }
            else {
                this.showError("Error " + result.status + ": " + result.msg);
            }
            StopLoading();
            return result.status == 200;
        }

        errorVisible: boolean = false;

        showError(msg: string) {
            this.errorVisible = true;
            SP.Sounds.Error.play();
            this.error.style.display = "block";
            this.error.innerHTML = msg;
            App_Picklist.instance.centerToCurrent();
        }

        clearError() {
            if (this.errorVisible) {
                this.errorVisible = false;
                this.error.style.display = "none";
                App_Picklist.instance.centerToCurrent();
            }
        }
    }

    class ToteInfo {
        id: number;
        name: string;
        color: string;
        constructor(id: number, name: string, color: string) {
            this.id = id;
            this.name = name;
            this.color = color;
        }
    }
}